var map = {
	"./decidim/avatar-multiuser.png": 77704,
	"./decidim/brands/facebook.svg": 23286,
	"./decidim/brands/google.svg": 64119,
	"./decidim/brands/twitter-x.svg": 49020,
	"./decidim/cc-badge.png": 46914,
	"./decidim/decidim-logo.svg": 97002,
	"./decidim/default-avatar.svg": 78838,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 29002,
	"./decidim/icons.svg": 61113,
	"./decidim/pattern.png": 2294,
	"./decidim/placeholder-card-g.svg": 95387,
	"./decidim/placeholder-card-l.svg": 71056,
	"./decidim/placeholder.jpg": 55543,
	"./decidim/remixicon.symbol.svg": 11279,
	"./decidim/vendor/social-share-button/douban.svg": 75966,
	"./decidim/vendor/social-share-button/email.svg": 19163,
	"./decidim/vendor/social-share-button/facebook.svg": 88669,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 96679,
	"./decidim/vendor/social-share-button/hacker_news.svg": 60319,
	"./decidim/vendor/social-share-button/linkedin.svg": 30755,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 75596,
	"./decidim/vendor/social-share-button/pinterest.svg": 31597,
	"./decidim/vendor/social-share-button/reddit.svg": 16509,
	"./decidim/vendor/social-share-button/telegram.svg": 74404,
	"./decidim/vendor/social-share-button/tumblr.svg": 68779,
	"./decidim/vendor/social-share-button/twitter.svg": 634,
	"./decidim/vendor/social-share-button/vkontakte.svg": 45508,
	"./decidim/vendor/social-share-button/wechat.svg": 29599,
	"./decidim/vendor/social-share-button/whatsapp.svg": 22751,
	"./decidim/vendor/social-share-button/x.svg": 83451,
	"./decidim/vendor/social-share-button/xing.svg": 84781
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16445;